export const EVENT_ATTRIBUTES_TYPES = {
  address: 1,
  tel: 2,
  email: 3,
  text: 4,
  switch: 5,
  list: 6,
  organization: 7,
  file: 8,
  full_text: 9,
  agreement: 10,
  // |¯ Ниже постоянные (дефолтные), которых нет возможности кастомизировать
  birthday: 11,
  region: 12,
  municipality: 13,
  snils: 14,
  class: 15,
  // |_ Конец постоянных
};

export const EVENT_ATTRIBUTES_TYPES_CONST_TYPES = [
  EVENT_ATTRIBUTES_TYPES.birthday,
  EVENT_ATTRIBUTES_TYPES.region,
  EVENT_ATTRIBUTES_TYPES.municipality,
  EVENT_ATTRIBUTES_TYPES.snils,
];

export const EVENT_ATTRIBUTES_TYPES_TEXT = {
  [EVENT_ATTRIBUTES_TYPES.address]: 'Адрес',
  [EVENT_ATTRIBUTES_TYPES.tel]: 'Телефон',
  [EVENT_ATTRIBUTES_TYPES.email]: 'Email',
  [EVENT_ATTRIBUTES_TYPES.text]: 'Ввод строки',
  [EVENT_ATTRIBUTES_TYPES.full_text]: 'Ввод большого текста',
  [EVENT_ATTRIBUTES_TYPES.switch]: 'Флажок (Согласие)',
  [EVENT_ATTRIBUTES_TYPES.list]: 'Выбор значения из списка',
  [EVENT_ATTRIBUTES_TYPES.file]: 'Выбор значения из списка (файл)',
  [EVENT_ATTRIBUTES_TYPES.organization]: 'Организация',
  [EVENT_ATTRIBUTES_TYPES.agreement]: 'Согласие',
  [EVENT_ATTRIBUTES_TYPES.birthday]: 'Дата рождения',
  [EVENT_ATTRIBUTES_TYPES.region]: 'Регион',
  [EVENT_ATTRIBUTES_TYPES.municipality]: 'Муниципалитет',
  [EVENT_ATTRIBUTES_TYPES.snils]: 'СНИЛС',
  [EVENT_ATTRIBUTES_TYPES.class]: 'Класс',
};

export const HIDDEN_EVENT_ATTRIBUTES = [
  EVENT_ATTRIBUTES_TYPES.file,
  EVENT_ATTRIBUTES_TYPES.birthday,
  EVENT_ATTRIBUTES_TYPES.region,
  EVENT_ATTRIBUTES_TYPES.municipality,
  EVENT_ATTRIBUTES_TYPES.snils,
];

export const MERGED_EVENT_ATTRIBUTES = {
  [EVENT_ATTRIBUTES_TYPES.list]: (data) => !data.options?.length ? EVENT_ATTRIBUTES_TYPES.file : EVENT_ATTRIBUTES_TYPES.list,
};

export const EVENT_ATTRIBUTES_KEYS = Object.fromEntries(
  Object.entries(EVENT_ATTRIBUTES_TYPES)
    .map(
      ([key, value]) => HIDDEN_EVENT_ATTRIBUTES.includes(value) ? null : [key, value],
    )
    .filter(Boolean),
);
